export default __webpack_public_path__ + "static/media/saritabohraBio.e24193f0.jpg";